/* eslint-disable no-console */
import { Menu, MenuItem } from './styles';

import geoAlert from 'services/utils/alert';

import ButtonTooltip from '../../ButtonTooltip';

import Icon from '@map/components/Icons';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 */
import { useState, useEffect } from 'react';
/**
 *  useModules é responsavel por gerenciar os modulos do GeoBahia,
 *  todos os módulos criados na ADM.
 * 
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import { useModule, useMap } from 'views/MapView/hooks';

/**
 * Função responsável por alterar o mapa base
 * 
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Setar o estado
 * @returns Um menu onde é existe algumas opções de 
 * mapa base.
 */
export const BaseMapSwitcher = ({ mapContext, isActive, setIsActive }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const [noBasemap, setNoBasemap] = useState(false);
  const open = Boolean(anchorEl);

  const { activeModule, getElement } = useModule();
  const { basemaps, changeBaseMap } = useMap();
  const [removeBasemap, setRemoveBasemap] = useState(false);

  /**
   * Muda copyright quando mapabase for da SCCON
   * @param {*} basemap Recebe o basemap que estara ativo
   */
  const changeAttribution = (basemap) => {
    if(!basemap) return

    const attributionElement = document.querySelector(".leaflet-control-attribution");
    if (!attributionElement) return;
  
    // Captura o prefixo Leaflet
    const leafletPrefix = attributionElement.innerHTML.split('|')[0].trim();
  
    let newAttribution = basemap.atribuicao;
  
    if (basemap.atribuicao?.includes('Planet Labs')) {
      const newDate = localStorage.getItem('mapPlanet');
      newAttribution = basemap.atribuicao.replace(/\(ano\)/, newDate);
    }
  
    // Atualiza o conteúdo mantendo o prefixo do Leaflet
    attributionElement.innerHTML = `${leafletPrefix} | ${newAttribution}`;
  };  

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
    setIsActive();
  };

  const handleClose = () => {
    setAnchorEl(null);
    setIsActive();
  };

  useEffect(() => {
    if (activeModule) {
      let mapTool = getElement('CPN-MA-MAP');
      setNoBasemap(mapTool?.configuracao?.hideBaseMap === '1' ? true : false);
    }
  }, [activeModule, getElement]);

  return (
    <div style={{ display: 'flex' }}>
      <ButtonTooltip
        tooltip={BaseMapSwitcher.properties.alias}
        description={BaseMapSwitcher.properties.description}
        style={{ marginRight: 15 }}
        onClick={(e) => {
          let mapTool = getElement('CPN-MA-MAP');          
          mapTool?.configuracao.informationalMessage !== false &&
            !isActive &&
            geoAlert({
              message: mapTool?.configuracao.message,
              configInformationalMessage: {
                optionDontShowAlertAgain: mapTool?.configuracao.optionNotShowAgain !== false,
                aliasModule: activeModule.apelido,
                toolId: BaseMapSwitcher.properties.id,
                aliasIdentifierCookie: 'dontShowInformationMessage',
                expireDays: mapTool?.configuracao.daysToExpire,
              },
            });
          anchorEl === null ? handleClick(e) : handleClose();
        }}
        active={isActive}
      >
        <Icon
          i="map-toolbar-basemap"
          width="17"
          height="17"
          style={{ verticalAlign: 'middle' }}
        />
      </ButtonTooltip>
      <Menu
        className="menu"
        anchorEl={anchorEl}
        getContentAnchorEl={null}
        keepMounted
        open={open}
        onClose={handleClose}
        elevation={3}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <div className="arrow" />
        <div className="items">
          {basemaps.map((basemap) => (
            <MenuItem
              onClick={() => {
                changeBaseMap(basemap.id);
                changeAttribution(basemap);
                setAnchorEl(null);
                if (removeBasemap) setRemoveBasemap(false);     
              }}
              style={{
                backgroundColor: basemap.active ? '#dce9ff' : '',
              }}
              key={basemap.id}
            >
              <div>
                <img
                  src={basemap.link
                    .replace('{s}', 'a')
                    .replace('{z}', '5')
                    .replace('{x}', '12')
                    .replace('{y}', '17')
                    .replace('{r}', '')}
                  alt="Ícone do módulo"
                />
                <div>
                  <h4>{basemap.titulo}</h4>
                </div>
              </div>
            </MenuItem>
          ))}
          {noBasemap && (
            <MenuItem
              onClick={() => {
                changeBaseMap(null);
                changeAttribution(null)
                setAnchorEl(null);
                setRemoveBasemap(true);
              }}
              style={{
                backgroundColor: removeBasemap ? '#dce9ff' : '',
              }}
            >
              <div>
                <div className="no-img">
                  <div className="backslash" />
                </div>
                <div>
                  <h4>Sem Mapa Base</h4>
                </div>
              </div>
            </MenuItem>
          )}
        </div>
      </Menu>
    </div>
  );
};

BaseMapSwitcher.properties = {
  id: 'CPN-TB-P-BASEMAP-SWITCHER',
  alias: 'Mapa Base',
  description: 'Seleciona o mapa base de sua preferência.',
};

export default BaseMapSwitcher;
